import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { setTaxPayer } from "../tax-payer/tax-payer-slice";
import { LOG_OUT } from "../reducers/user";

export interface PermissionsState {
  loaded: boolean;
  loading: boolean;
  permissions: string[];
  taxPayerId?: number;
}

const initialState: PermissionsState = {
  loaded: false,
  loading: true,
  permissions: [],
};

export const taxPayerPerissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setTaxPayerPermissionsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTaxPayerPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
      state.loading = false;
      state.loaded = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(LOG_OUT, () => initialState);
    builder.addCase(setTaxPayer, (state, action) => {
      if (state.taxPayerId !== action.payload.id)
        return { ...initialState, taxPayerId: action.payload.id };
    });
  },
});

export const { setTaxPayerPermissionsLoading, setTaxPayerPermissions } =
  taxPayerPerissionsSlice.actions;

export default taxPayerPerissionsSlice.reducer;
